import axios from "axios";

const CreatAxios = (props = {}) => {
    var gett = localStorage.getItem("apiToken");
    var customerNo = localStorage.getItem("customerNo");
    var userId = localStorage.getItem("userId");
    let congData = JSON.stringify({
        customerNumber: customerNo,
        userId: userId,
        customer_no: +customerNo,
        customerNo: +customerNo,
        user_id: +userId,
        ...props.payload,
    });

    const apiURL = props.completeURL
        ? `${props.completeURL}`
        : `${process.env.REACT_APP_MASTER_API}/${props.url}`;

    const publicURL = props.publicURL ? `${props.publicURL}` : ''

    if (props.completeURL) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(apiURL, congData, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: `${gett}`,
                        },
                    })
                    .then((res) => {
                        console.log("axios component", res.data);
                        resolve(res);
                    })
                    .catch((err) => {
                        console.log("err", err);
                        reject(err);
                    });
            });
        } catch (error) {
            return console.log("Error Create", error);
        }
    }
    else if (props.approveURL) {
        console.log(" url : ", props.approveURL)
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(props.approveURL, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: `${gett}`,
                        },
                    })
                    .then((res) => {
                        console.log("axios component", res.data);
                        resolve(res);
                    })
                    .catch((err) => {
                        console.log("err", err);
                        reject(err);
                    });
            });
        } catch (error) {
            return console.log("Error Create", error);
        }
    }
    else if (props.publicURL) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(publicURL, congData, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            // Authorization: `${gett}`,
                        },
                    })
                    .then((res) => {
                        console.log("axios component", res.data);
                        resolve(res);
                    })
                    .catch((err) => {
                        console.log("err", err.response);
                        reject(err);
                    });
            });
        } catch (error) {
            return console.log("Error Create", error);
        }
    }
    else {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(apiURL, congData, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: `${gett}`,
                        },
                    })
                    .then((res) => {
                        console.log("axios component", res.data);
                        if (res.data.status === 200) {
                            resolve(res);
                        } else {
                            console.log("Error", res.data);
                            reject(res);
                        }
                    })
                    .catch((err) => {
                        console.log("err", err);
                        reject(err);
                    });
            });
        } catch (error) {
            return console.log("Error Create", error);
        }
    }
};

export default CreatAxios;
